import { SortDirection } from 'dy-frontend-http-repository/lib/data/enums';
import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { SortData } from 'dy-frontend-http-repository/lib/data/types';
import { CoreUserListItemResource } from 'dy-frontend-http-repository/lib/modules/CoreUser/resources';
import { initialPlatformCoreUserFilterData } from '../consts';
import { CoreUserSortField } from '../enums';
import { PlatformCoreUserFilterData } from '../types';
import domain from './domain';
import { resetCoreUsers, resetPlatformCoreUserFilterData, resetIsQueryHydrationFinished, resetPage, resetCoreUserSortData } from './events';

// Core users
export const $coreUsers = domain
    .createStore<CollectionResource<CoreUserListItemResource, {}> | null>(null)
    .reset(resetCoreUsers);

// Page
export const $page = domain.createStore<number>(1).reset(resetPage);

// Initialization flag for hydration finished
export const $isQueryHydrationFinished = domain.createStore<boolean>(false).reset(resetIsQueryHydrationFinished);

// Platform core user filter data
export const $platformCoreUserFilterData = domain
    .createStore<PlatformCoreUserFilterData>(initialPlatformCoreUserFilterData)
    .reset(resetPlatformCoreUserFilterData);

// Sort data
export const $coreUserSortData = domain
    .createStore<SortData<CoreUserSortField>>({
        field: CoreUserSortField.NAME,
        direction: SortDirection.ASC,
    })
    .reset(resetCoreUserSortData);
